import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import InputForm from '../site/layout/InputForm';

interface EditMikrotikProps extends RouteComponentProps<{ id: string }> {
    changeToggle(action?: boolean): void
}

@observer export default class EditMikrotik extends React.Component<EditMikrotikProps> {

    @observable private router: any = {
        name: "",
        ip: "",
        username: "",
        password: ""
    };
    @observable private redirect = false;
    @observable private validationErrors: string[] = [];
    @observable private isLoaded = false;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        const id = this.props.match.params.id;
        if (!id || id === "undefined") {
            toast.error("Error cargando el router MikroTik");
            this.redirect = true;
            return;
        }
        http.get(`/api/mikrotik_router/read/${id}`).then((response) => {
            const data = response.data;
            let r: any = data && data.response;
            if (Array.isArray(r)) {
                r = r[0];
            }
            if (r == null || typeof r !== "object") {
                r = data && typeof data === "object" && !Array.isArray(data) ? data : null;
            }
            if (r == null) {
                toast.error("Error cargando el router MikroTik");
                this.redirect = true;
                return;
            }
            this.router = { ...r };
            const nameVal = r.name != null && String(r.name) !== "" ? r.name : r.nombre;
            const userVal = r.username != null && String(r.username) !== "" ? r.username : r.usuario;
            this.router.name = nameVal != null ? String(nameVal) : "";
            this.router.username = userVal != null ? String(userVal) : "";
            delete this.router.nombre;
            delete this.router.usuario;
            this.isLoaded = true;
        }).catch(() => {
            toast.error("Error cargando el router MikroTik");
            this.redirect = true;
        });
    }

    private handleChange = (event: any) => {
        const { name, value } = event.target;
        this.router[name] = value;
    }

    private setValidation = (value: boolean, name: string): void => {
        const error = this.validationErrors.indexOf(name);
        if (value && error === -1) {
            this.validationErrors.push(name);
        } else if (!value && error !== -1) {
            this.validationErrors.splice(error, 1);
        }
    }

    private onSubmit = (): void => {
        if (this.validationErrors.length > 0) {
            toast.error("Hay un error en tu formulario");
            return;
        }

        http.post(`/api/mikrotik_router/update`, JSON.stringify(this.router))
            .then(() => {
                toast.success(`Router MikroTik actualizado`);
                this.redirect = true;
            }).catch((error) => {
                if (Array.isArray(error)) {
                    error.forEach((val) => {
                        toast.error(val);
                    })
                } else {
                    toast.error(error.message || error);
                }
            });
    }

    render() {
        if (this.redirect) {
            const id = this.router && (this.router.id || this.props.match.params.id);
            const url = id ? `/mikrotik/ver/${id}` : "/mikrotik";
            return <Redirect to={url} />
        }
        if (!this.isLoaded) {
            return null;
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-rose card-header-text">
                                <div className="card-text">
                                    <h4 className="card-title">Editar router: {this.router.name}</h4>
                                </div>
                            </div>
                            <div className="card-body ">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        <Link to={`/mikrotik`}>
                                            <button className="btn btn-danger btn-sm pull-right">
                                                <i className="material-icons">highlight_off</i>
                                                <div className="ripple-container"></div>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                                <InputForm
                                    name="name"
                                    label="Nombre"
                                    value={this.router.name}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <InputForm
                                    name="ip"
                                    label="IP"
                                    value={this.router.ip}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <InputForm
                                    name="username"
                                    label="Usuario"
                                    value={this.router.username}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="text"
                                />
                                <InputForm
                                    name="password"
                                    label="Password"
                                    value={this.router.password}
                                    setValidation={this.setValidation}
                                    required={true}
                                    onChange={this.handleChange}
                                    type="password"
                                    enforceStrongPassword={false}
                                    showPasswordToggle={true}
                                />
                                <div className="row">
                                    <div className="col-md-12">
                                        <button onClick={this.onSubmit} type="button" className="btn btn-primary pull-right">Guardar Cambios</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        )
    }
}
